/**
 * CareZoneService
 * Service for managing the care zone catalog
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for care zone catalog CRUD operations
 */
export class CareZoneService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CareZoneService.DEFAULT_SERVICE_PATH,
            basePath: CareZoneService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
CareZoneService.DEFAULT_SERVICE_PATH = 'ac-counselling';
CareZoneService.BASE_PATH = 'api/care-zones';
//# sourceMappingURL=CareZoneService.js.map